import {
  ELongSteelOrdersStatus,
  IQCColumnState,
  INFEColumnState
} from '../long-steel-orders/types';
import { EInvoiceStatus, IInvoiceBilletState } from '../invoices/types';

// Action Types
export enum Types {
  LOAD_CUSTOMER_NFS_AND_QUALITY_CERTIFICATES = 'downloadArea/LOAD_CUSTOMER_NFS_AND_QUALITY_CERTIFICATES',
  LOAD_CUSTOMER_NFS_AND_QUALITY_CERTIFICATES_SUCCESS = 'downloadArea/LOAD_CUSTOMER_NFS_AND_QUALITY_CERTIFICATES_SUCCESS',
  LOAD_CUSTOMER_NFS_AND_QUALITY_CERTIFICATES_FAILURE = 'downloadArea/LOAD_CUSTOMER_NFS_AND_QUALITY_CERTIFICATES_FAILURE',

  LOAD_CUSTOMER_BILLETS = 'downloadArea/LOAD_CUSTOMER_BILLETS',
  LOAD_CUSTOMER_BILLETS_SUCCESS = 'downloadArea/LOAD_CUSTOMER_BILLETS_SUCCESS',
  LOAD_CUSTOMER_BILLETS_FAILURE = 'downloadArea/LOAD_CUSTOMER_BILLETS_FAILURE',

  LOAD_QC_FILE = 'downloadArea/LOAD_QC_FILE',
  LOAD_QC_FILE_SUCCESS = 'downloadArea/LOAD_QC_FILE_SUCCESS',
  LOAD_QC_FILE_FAILURE = 'downloadArea/LOAD_QC_FILE_FAILURE',
  DOWNLOAD_QC_FILE = 'downloadArea/DOWNLOAD_QC_FILE',
  LOAD_BILLET_FILE = 'downloadArea/LOAD_BILLET_FILE',
  LOAD_BILLET_FILE_SUCCESS = 'downloadArea/LOAD_BILLET_FILE_SUCCESS',
  LOAD_BILLET_FILE_FAILURE = 'downloadArea/LOAD_BILLET_FILE_FAILURE',
  DOWNLOAD_BILLET_FILE = 'downloadArea/DOWNLOAD_BILLET_FILE',

  LOAD_NF_FILE = 'downloadArea/LOAD_NF_FILE',
  LOAD_NF_FILE_SUCCESS = 'downloadArea/LOAD_NF_FILE_SUCCESS',
  LOAD_NF_FILE_FAILURE = 'downloadArea/LOAD_NF_FILE_FAILURE',
  DOWNLOAD_NF_FILE = 'downloadArea/DOWNLOAD_NF_FILE',

  CLEAN_DOWNLOAD_AREA_STATE = 'downloadArea/CLEAN_DOWNLOAD_AREA_STATE',

  LOAD_NF_XML_FILE = 'downloadArea/LOAD_NF_XML_FILE',
  LOAD_NF_XML_FILE_SUCCESS = 'downloadArea/LOAD_NF_XML_FILE_SUCCESS',
  LOAD_NF_XML_FILE_FAILURE = 'downloadArea/LOAD_NF_XML_FILE_FAILURE',
  DOWNLOAD_NF_XML_FILE = 'downloadArea/DOWNLOAD_NF_XML_FILE'
}

export interface IDownloadAreaState {
  customerId: string;
  startDate: string;
  endDate: string;

  nfsState: ICustomerNFsState;
  billetsState: ICustomerBilletsState;
  qualityCertificatesState: ICustomerQualityCertificateState;
}

export interface ICustomerNFsState {
  loading: boolean;
  error: boolean;
  items: ICustomerNFItem[];
}

export interface ICustomerNFItem {
  orderNumber: string;
  invoiceNumber: string;
  key: number;
  itemBillingDate: string;
  status: ELongSteelOrdersStatus;
  totalValue: string;
  billingNumber: string;
  danfeNumber: string;
  nfState?: INFEColumnState;
  nfXmlState?: INFEColumnState;
}

export interface ICustomerBilletsState {
  loading: boolean;
  error: boolean;
  items: ICustomerBilletItem[];
}

export interface ICustomerBilletResponse {
  customer: string;
  billing: string;
  link: string;
  duedate: string;
  barCode: string;
  dateOfCreation: string;
}

export interface ICustomerBilletItem {
  invoiceNumber: string;
  orderNumber: string;
  key: number;
  totalValue: string;
  billingDate: string;
  dueDate: string;
  status: EInvoiceStatus;
  taxNumberAccount: string;
  customerCnpj: string;
  bankSlipNumber: string;
  bankCode: string;
  documentType: string;
  invoiceType: string;
  billingNumber: string;
  billetState?: IInvoiceBilletState;
}
export interface ICustomerQualityCertificateState {
  loading: boolean;
  error: boolean;
  items: ICustomerQualityCertificateItem[];
}

export interface ICustomerQualityCertificateItem {
  key: number;
  orderNumber: string;
  invoiceNumber: string;
  sku: string;
  customerSKU: string;
  itemBillingDate: string;
  materialDescription: string;
  canDownloadQC: boolean;
  cqNumber: string;
  deliveryCode: string;
  deliveryItemCode: string;
  alreadyDownloaded?: boolean;

  qcState?: Omit<IQCColumnState, 'canDownloadQC'>;
}
